interface Allowlist {
  domains: string[]
  emails: string[]
}

const HIREHIRE_DOMAIN = 'hirehire.me'

const atsAllowlist: Allowlist = {
  domains: [HIREHIRE_DOMAIN, 'scorewarrior.com'],
  emails: [
    'verycrazyslava@gmail.com',
    'pansslava@gmail.com',
    'fernanda.bergamaschi@emergingtravel.com',
    'fairy@fairyslavik.com',
  ],
}

const publicApiAllowlist: Allowlist = {
  domains: [HIREHIRE_DOMAIN, 'tabby.ai', 'tabby.sa', 'flowwow.com'],
  emails: [
    'verycrazyslava@gmail.com',
    'pansslava@gmail.com',
    'fairy@fairyslavik.com',
    'dinaveprikova@gmail.com',
  ],
}

const liveTranscriptionAllowlist: Allowlist = {
  domains: [HIREHIRE_DOMAIN],
  emails: [
    'verycrazyslava@gmail.com',
    'pansslava@gmail.com',
    'fairy@fairyslavik.com',
  ],
}

const domainOf = (email: string): string => {
  const separatorIndex = email.lastIndexOf('@')
  if (separatorIndex === -1) return ''
  return email.slice(separatorIndex + 1)
}

/**
 * Matches the exact domain and its subdomains, so `hirehire.me` accepts
 * `someone@hirehire.me` and `someone@mail.hirehire.me` but rejects a
 * look-alike such as `someone@hirehire.me.example.com`.
 */
const belongsToDomain = (host: string, domain: string): boolean =>
  host === domain || host.endsWith(`.${domain}`)

const isAllowlisted = (email: string, allowlist: Allowlist): boolean => {
  const normalizedEmail = email.trim().toLowerCase()
  if (!normalizedEmail) return false

  if (allowlist.emails.includes(normalizedEmail)) return true

  const host = domainOf(normalizedEmail)
  if (!host) return false

  return allowlist.domains.some((domain) => belongsToDomain(host, domain))
}

export const isAllowlistedForATS = (email: string = '') =>
  isAllowlisted(email, atsAllowlist)

export const isAllowlistedForPublicApi = (email: string = '') =>
  isAllowlisted(email, publicApiAllowlist)

export const isAllowlistedForLiveTranscription = (email: string = '') =>
  isAllowlisted(email, liveTranscriptionAllowlist)

export const isAllowlistedForInterviewPdfExport = (_email: string = '') => {
  // Rolled out to all users. To re-tighten access, define an Allowlist above
  // and route this through isAllowlisted like the helpers next to it.
  return true
}
